export default __webpack_public_path__ + "static/media/dos-03@2x.7d8fcf58.jpg";